<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(filterdata)" class="mb-5">
                <v-card>
                  <v-expansion-panels v-model="panel" multiple focusable>
                    <v-expansion-panel>
                      <v-expansion-panel-header>{{
                        $t("language.filter")
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-card-text>
                          <v-container grid-list-xl>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.departmentid"
                                  :items="DepartmentList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.department')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.branchid"
                                  :items="BranchList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.branch')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.designationid"
                                  :items="DesignationList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.designation')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm6 md3>
                                <v-autocomplete
                                  dense
                                  v-model="filter.personid"
                                  :items="PersonList"
                                  item-text="name"
                                  item-value="id"
                                  :label="$t('language.person')"
                                  :clearable="true"
                                ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 sm12 md3>
                                <ValidationProvider
                                  :name="$t('language.fromdate')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="filter.fromdate"
                                    :label="$t('language.fromdate')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                              <v-flex xs12 sm12 md3>
                                <ValidationProvider
                                  :name="$t('language.todate')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <eng-nep-date-picker
                                    :error-messages="errors[0]"
                                    v-model="filter.todate"
                                    :label="$t('language.todate')"
                                  ></eng-nep-date-picker>
                                </ValidationProvider>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn
                            dense
                            color="general"
                            class="mr-2"
                            light
                            type="submit"
                            >{{ $t("language.filter") }}</v-btn
                          >
                          <v-btn
                            dense
                            class="mr-2"
                            light
                            @click="resetFilter"
                            >{{ $t("language.clear") }}</v-btn
                          >
                        </v-card-actions>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card>
              </v-form>
            </ValidationObserver>
            <ValidationObserver
              ref="form"
              v-slot="{ passes }"
              v-if="models.length > 0"
            >
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">
                                    {{ $t("language.person") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.designation") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.date") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.intime") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.outtime") }}
                                  </th>
                                  <th class="text-left">
                                    {{ $t("language.type") }}
                                  </th>
                                  <th class="text-left">
                                    <v-autocomplete
                                      dense
                                      v-model="leaveid"
                                      :items="LeaveList"
                                      item-text="name"
                                      item-value="id"
                                      :label="$t('language.leave')"
                                      :clearable="true"
                                    ></v-autocomplete>
                                  </th>
                                  <th class="text-left">
                                    <v-autocomplete
                                      dense
                                      v-model="approvedbyid"
                                      :items="ApproverList"
                                      item-text="name"
                                      item-value="id"
                                      :label="$t('language.approver')"
                                      :clearable="true"
                                    ></v-autocomplete>
                                  </th>
                                  <th class="text-left">
                                    <v-textarea
                                      dense
                                      v-model="remarks"
                                      :label="$t('language.remarks')"
                                    ></v-textarea>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(item, index) in models"
                                  :key="index"
                                >
                                  <td>{{ item.person }}</td>
                                  <td>{{ item.designation }}</td>
                                  <td>{{ getDefaultDate(item.date) }}</td>
                                  <td>{{ item.intime }}</td>
                                  <td>{{ item.outtime }}</td>
                                  <td>{{ item.statusshorttext }}</td>
                                  <td>{{ item.leave }}</td>
                                  <td>{{ item.approver }}</td>
                                  <td>
                                    <v-textarea
                                      dense
                                      v-model="item.remarks"
                                      :label="$t('language.remarks')"
                                    ></v-textarea>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="blue darken-1" text type="submit">{{
                      $t("language.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import EngNepDatePicker from "../../../components/shared/EngNepDatePicker";
import Base from "../../../shared/Base.vue";
import commonservice from "../../../shared/common.service";
export default {
  name: "dayoffworkingview",
  extends: Base,
  components: {
    EngNepDatePicker,
  },
  data() {
    return {
      filter: {},
      panel: [1],
      DepartmentList: [],
      BranchList: [],
      PersonList: [],
      DesignationList: [],
      LeaveList: [],
      ApproverList: [],
      models: [],
      leaveid: null,
      approvedbyid: null,
      remarks: null,
    };
  },
  watch: {
    leaveid: function(newvalue, oldvalue) {
      var leave = this.LeaveList.filter((item) => {
        return item.id == newvalue;
      })[0];
      let name = leave != null ? leave.name : null;
      this.models.forEach((item) => {
        item.leaveid = newvalue;
        item.leave = name;
      });
    },
    approvedbyid: function(newvalue, oldvalue) {
      var approver = this.ApproverList.filter((item) => {
        return item.id == newvalue;
      })[0];
      let name = approver != null ? approver.name : null;
      this.models.forEach((item) => {
        item.approvedbyid = newvalue;
        item.approver = name;
      });
    },
    remarks: function(newvalue, oldvalue) {
      this.models.forEach((item) => {
        item.remarks = newvalue;
      });
    },
  },
  created() {
    this.resetFilter();
    this.url = "client/posting/dayoffworkings";
    this.panel = [...Array(1).keys()].map((k, i) => i);
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/posting/dayoffworkings/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.PersonList = response.data.persons;
        p.DesignationList = response.data.designations;
        p.LeaveList = response.data.leaves;
        p.ApproverList = response.data.approvers;
      });
    });
  },
  methods: {
    resetFilter() {
      this.filter = {
        fromdate: moment().format("YYYY-MM-DD"),
        todate: moment().format("YYYY-MM-DD"),
        branchid: null,
        departmentid: null,
        personid: null,
      };
    },
    filterdata() {
      axios
        .get(
          "client/posting/dayoffworkings?" +
            this.convertToQueryString(this.filter)
        )
        .then((response) => {
          this.models = response.data;
          this.isEdit = true;
          if (this.models.length == 0) {
            this.$store.dispatch(
              "showErrorMessage",
              this.$t("language.nodatafound")
            );
          }
        });
    },
    beforeSave() {
      this.vModel = this.models.filter((item) => {
        return (
          item.leaveid != null &&
          item.approvedbyid != null &&
          item.remarks != null
        );
      });
      return true;
    },
  },
};
</script>
<style>
.v-data-table .v-select__selection {
  font-size: 12px;
  font-weight: normal;
}
</style>
